import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, useNavigate, useLocation } from 'react-router-dom'
import * as Sentry from "@sentry/react"
import { supabase } from './lib/supabase'
import Login from './components/Login'
import ProcurementApp from './components/ProcurementApp'
import { AppProvider } from './components/AppContext'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  beforeSend(event) {
    if (import.meta.env.DEV) return null;
    return event;
  },
})

// HashRouter is outermost — never remounts.
// AppProvider wraps everything so all data is in context.

function AppWithRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  const [session, setSession] = useState(undefined)

  useEffect(() => {
    // Ensure the URL always has a hash so browser back doesn't land on bare domain
    if (location.pathname === '/') {
      navigate('/items', { replace: true })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
    return () => subscription.unsubscribe()
  }, [])

  if (session === undefined) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f3' }}>
        <div style={{ color: '#999', fontSize: 14 }}>Loading…</div>
      </div>
    )
  }

  if (!session) return <Login />

  return (
    <AppProvider>
      <ProcurementApp
        onSignOut={() => supabase.auth.signOut()}
        currentPath={location.pathname}
        onNavigate={(path) => navigate(path)}
      />
    </AppProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <Sentry.ErrorBoundary fallback={<div style={{padding:40,textAlign:'center',fontFamily:'DM Sans,sans-serif'}}>Something went wrong. Please refresh the page.</div>}>
        <AppWithRouter />
      </Sentry.ErrorBoundary>
    </HashRouter>
  </React.StrictMode>
)
